import {Injectable} from '@angular/core';
import {FormControl, Validators, FormBuilder, FormGroup, AbstractControl} from "@angular/forms";

@Injectable()
export class MarcacaoBlocoModel {

  public field: any = {

    quantidade:   <string> '',
    num_pedreira:     <string> '',
    material:     <string> '',
    comprimento:     <string> '',
    largura:     <string> '',
    altura:     <string> '',
    preco:     <string> '',
    desconto:     <string> '',
    obs:     <string> '',

    info_val:     <string> '8,56 M³ x R$ 200,00 = R$ 1.712,00',

    files: <any> []

  };

  constructor(public formBuilder: FormBuilder) {
    this.resetForm();
  }

  resetForm() {
    for (let prop in this.field) {
      // eval("this.field." + prop + " = '' ");
    };
  }

}



// WEBPACK FOOTER //
// ./src/model/marcacao-bloco.model.ts